import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { FOUNDATION_INFO, FOUNDATION_LOGO } from "@/lib/initiatives";
import NewsletterForm from "@/components/NewsletterForm";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A2540] text-white/90 mt-24">
      <div className="mx-auto max-w-7xl container-x py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg overflow-hidden flex items-center justify-center">
              <img src={FOUNDATION_LOGO} alt="UB Maitreya Foundation" className="w-full h-full object-cover" />
            </div>
            <div className="leading-tight">
              <div className="font-serif-display text-lg text-white">UB Maitreya</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[#D4AF37]">
                Foundation
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/70 max-w-xs">
            {FOUNDATION_INFO.tagline} A Section 8 registered non-profit building a
            healthier, educated and prosperous India.
          </p>
          <div className="mt-6">
            <div className="text-xs uppercase tracking-[0.18em] text-[#D4AF37] mb-3">
              Newsletter
            </div>
            <NewsletterForm />
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.18em] text-[#D4AF37] mb-4">
            Explore
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-[#D4AF37]" to="/initiatives">Our Initiatives</Link></li>
            <li><Link className="hover:text-[#D4AF37]" to="/events">Events & Recognition</Link></li>
            <li><Link className="hover:text-[#D4AF37]" to="/about">About & Directors</Link></li>
            <li><Link className="hover:text-[#D4AF37]" to="/csr">CSR Partnerships</Link></li>
            <li><Link className="hover:text-[#D4AF37]" to="/volunteer">Volunteer</Link></li>
            <li><Link className="hover:text-[#D4AF37]" to="/donate">Donate (80G)</Link></li>
            <li><Link className="hover:text-[#D4AF37]" to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.18em] text-[#D4AF37] mb-4">
            Reach Us
          </h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> {FOUNDATION_INFO.address}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> <a href={`tel:${FOUNDATION_INFO.phone}`} className="hover:text-[#D4AF37]">{FOUNDATION_INFO.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> <a href={`mailto:${FOUNDATION_INFO.email}`} className="hover:text-[#D4AF37]">{FOUNDATION_INFO.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.18em] text-[#D4AF37] mb-4">
            Credentials
          </h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><span className="text-white/60">CIN:</span> {FOUNDATION_INFO.cin}</li>
            <li><span className="text-white/60">PAN:</span> {FOUNDATION_INFO.pan}</li>
            <li><span className="text-white/60">80G No:</span> {FOUNDATION_INFO.reg80g}</li>
            <li><span className="text-white/60">NGO Darpan:</span> {FOUNDATION_INFO.darpan}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl container-x py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} UB Maitreya Foundation. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#D4AF37]">Admin</Link>
            <span>Section 8 Company</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
